// extracted by mini-css-extract-plugin
export default {"CatalogPreviewModal":"_3KhERG_i3Xpvxa4Jo4-KxK"};